import * as log from "@/actions/logger";

// Allowed locales for Contentful and the app
export const VALID_LANGS = ["en-US", "es"];
export type SupportedLang = (typeof VALID_LANGS)[number];

// Mapping of Contentful locales to simplified codes (for URLs, analytics, etc.)
const langIndex: Record<SupportedLang, string> = {
  "en-US": "en",
  es: "es",
};

/**
 * Returns the short language code ("en", "es") based on a Contentful locale ("en-US", "es")
 */
export const getLanguageIndex = (lang: string): string => {
  return langIndex[validateLanguage(lang)];
};

/**
 * Ensures the locale is valid.
 * Falls back to "en-US" if not valid.
 */
export function validateLanguage(lang?: string): SupportedLang {
  if (!lang || !VALID_LANGS.includes(lang as SupportedLang)) {
    log.warn(
      { module: "utils/language.ts" },
      `[validateLanguage] Invalid locale "${lang}", falling back to "en-US"`
    );
    return "en-US";
  }
  return lang as SupportedLang;
}
